import React, { Component } from 'react';
import { inject } from 'mobx-react';
import cn from 'classnames';
import Uppy from '@uppy/core';
import FileInput from '@uppy/file-input';
import XHRUpload from '@uppy/xhr-upload';
import Humanize from 'humanize-plus';

import uploadLogo from '../../assets/images/upload_icon.svg';

import '@uppy/drag-drop/dist/style.css';
import './textbox-button-upload-files.scss';

class TextboxButtonUploadFiles extends Component {
	state = {
		previewImage: '',
		previewName: '',
		previewSize: '',
	};

	componentDidMount() {
		const {
			uppyTarget, uppyEndpoint, authService, userStore, handleFileChange, showValidationMessage,
		} = this.props;

		this.uppy
			.use(FileInput, {
				target: `.${uppyTarget}`,
				replaceTargetContent: true,
			})
			.use(XHRUpload, {
				endpoint: uppyEndpoint,
				fieldName: 'file',
				headers: {
					Authorization: `Bearer ${authService.getAccessToken()}`,
					'X-Group': userStore.profile.id,
				},
			})
			.on('complete', (result) => {
				result.successful.map((successfulFile) => {
					handleFileChange({ id: successfulFile.response.body.id });

					this.setState({
						previewImage: successfulFile.response.body.url,
						previewName: successfulFile.response.body.name,
						previewSize: successfulFile.response.body.size,
					});

					return successfulFile;
				});
			})
			.on('info-visible', () => {
				const { type, message } = this.uppy.getState().info;
				showValidationMessage({ code: 'text-button-upload', color: type, message });
			});
	}

	static getDerivedStateFromProps(props, state) {
		let retState = null;

		if (!state.previewImage && props.field.value && props.field.value.id) {
			retState = {
				previewImage: props.field.value.url,
				previewName: props.field.value.name,
				previewSize: props.field.value.size,
			};
		}

		return retState;
	}

	uppy = new Uppy({
		autoProceed: true,
		restrictions: {
			allowedFileTypes: this.props.validFormats,
		},
		onBeforeFileAdded: (currentFile) => {
			const fileLowerCase = { ...currentFile };
			fileLowerCase.name = fileLowerCase.name.toLowerCase();
			return fileLowerCase;
		},
	});

	removeFile = () => {
		this.setState({
			previewImage: '',
			previewName: '',
			previewSize: '',
		});

		this.props.handleFileChange({});
	};

	render() {
		const {
			label, buttonText, placeholder, uppyTarget, disabled,
		} = this.props;
		const { previewImage, previewName, previewSize } = this.state;

		return (
			<div className="textbox-button-upload-files">
				{label && <div className="upload-label">{label}</div>}

				<div className={cn('upload-control', { disabled })}>
					<div className="filename">{previewName || placeholder}</div>

					<div className="tertiary-button">
						<img className="upload-icon" src={uploadLogo} alt="" />
						{buttonText}
						<div className={uppyTarget} />
					</div>
				</div>

				{previewImage && (
					<div className="preview">
						<div className="preview-image-wrapper">
							<img className="preview-image" src={previewImage} alt="preview" />
							<i
								className={cn('material-icons remove-file', { 'd-none': disabled })}
								onClick={this.removeFile}
							>
								{'cancel'}
							</i>
						</div>

						<div className="file-info">
							<div className="filename">{previewName}</div>
							<div className="file-size">{Humanize.fileSize(previewSize)}</div>
						</div>
					</div>
				)}
			</div>
		);
	}
}

export default inject('authService', 'userStore')(TextboxButtonUploadFiles);
